import { cx } from 'lib/cx'
import type { EditorVariants } from '.'
import styles from './styles.module.css'

export function Header({
  className,
  children,
  variant,
}: {
  className?: string
  children: React.ReactNode
  variant: EditorVariants
}) {
  return (
    <div className={cx(styles.header, styles[variant ?? 'default'], className)}>
      {children}
    </div>
  )
}
